<div class="common-screen">
  <div style="height:80px">
      <div fxLayoutAlign="center center"
          style="display:flex;gap:20px;align-items:center;margin-bottom:10px;padding-top:20px;">

          <button mat-flat-button class="btn-action btn-with-icon" color="accent"
              (click)="router.navigate(['rekbot-settings', rekbotID])" matTooltip="Ustawienia Rekbota"><img style="width:25px;" src="/assets/img/back.png"
                  alt="">Powrót</button>
      </div>
  </div>
  <mat-card class="list-container">
      <mat-card-content>
          <div class="row">
              <div class="col">
                  <h3>Kreator</h3>


                  <div>
                    <app-blocks-creator rekbotID=rekbotID></app-blocks-creator>
                  </div>
                  <hr>
                  <mat-card appearance="outlined">
                    <mat-card-content>
                      <h2>Formatowanie paragonu</h2>
                      <h5>Wydruk</h5>
                      <div class="row">
                        <div class="col" style="display: flex;gap:5px;">
                          <mat-form-field>
                            <mat-label>Gęstość druku:</mat-label>
                            <input matInput type="text" [(ngModel)]="printDensity">
                          </mat-form-field>
                  
                          <mat-form-field>
                            <mat-label>Strona kodowa:</mat-label>
                            <input matInput type="text" [(ngModel)]="codeTable">
                          </mat-form-field>
                  
                        </div>
                      </div>
                      <hr>
                      <h5>Elementy</h5>
                      <div class="component-container">
                        <h5>Bloki dostępne</h5>
                        <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="blockService.getList()"
                          [cdkDropListConnectedTo]="[doneList]" class="component-list">
                          @for (item of blockService.getList(); track item) {
                          <div class="component-box" cdkDrag>{{item.name}}</div>
                          }
                        </div>
                      </div>
                  
                      <div class="component-container">
                        <h5>Elementy paragonu</h5>
                        <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="receipt" class="component-list"
                          (cdkDropListDropped)="drop($event)">
                          @for (item of receipt; track item) {
                          <div class="component-box" cdkDrag>{{item.name}} <mat-icon (click)="removeItem(item)" style="cursor:pointer;">clear</mat-icon></div>
                          }
                        </div>
                      </div>
                      <hr>
                      <h5>Cut</h5>
                      <div class="row">
                        <div class="col" style="display: flex;gap:5px;">
                          <mat-form-field>
                            <mat-label>Liczba kroków:</mat-label>
                            <input matInput type="text" [(ngModel)]="numberOfSteps">
                          </mat-form-field>
                  
                          <mat-form-field>
                            <mat-label>Mruganie LED:</mat-label>
                            <input matInput type="text" [(ngModel)]="ledBlinking">
                          </mat-form-field>
                  
                          <mat-form-field>
                            <mat-label>ticketMovement:</mat-label>
                            <input matInput type="text" [(ngModel)]="ticketMovement">
                          </mat-form-field>
                  
                          <mat-form-field>
                            <mat-label>Timeout:</mat-label>
                            <input matInput type="text" [(ngModel)]="timeout">
                          </mat-form-field>
                  
                  
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="saveReceipt()"
                            [disabled]="receipt.length == 0">Zapisz szablon wydruku paragonu</button>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>

              </div>
          </div>
      </mat-card-content>
  </mat-card>
  <div style="height:50px">

  </div>
</div>


